<template>
    <div class="col-sm-4 wow fadeIn" data-wow-duration="2s" data-wow-delay=".5s">
      <div class="news-overview">
        <a v-bind:href="href" class="news-img full">
          <img v-bind:src="image" v-bind:alt="title" />
        </a>
        <div class="news-description">
          <span class="news-time">{{date}}</span>
          <a v-bind:href="href" class="title-like-link">{{title}}</a>
          <div v-html="content"></div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Article',

  props: ['index', 'title', 'content', 'href', 'image', 'date']
}

</script>